import { useNavigate, useLocation } from 'react-router-dom';

import { useIntl } from '@edx/frontend-platform/i18n';
import { Tabs, Tab } from '@openedx/paragon';
import { getConfig } from '@edx/frontend-platform';
import { ROUTES } from '../../constants';

import messages from './messages';

function NavigationBar() {
  const intl = useIntl();
  const NavigationTabs = [
    {
      id: 'learnerRecords',
      path: ROUTES.PROGRAM_RECORDS,
    },
  ];

  if (getConfig().ENABLE_VERIFIABLE_CREDENTIALS) {
    NavigationTabs.push({
      id: 'verifiableCredentials',
      path: ROUTES.VERIFIABLE_CREDENTIALS,
    });
  }

  const navigate = useNavigate();
  const location = useLocation();

  return NavigationTabs.length > 1 ? (
    <Tabs
      className="mt-1 mb-5"
      defaultActiveKey={location.pathname}
      onSelect={path => navigate(path)}
    >
      {NavigationTabs.map(tab => (
        <Tab
          key={tab.id}
          eventKey={tab.path}
          title={intl.formatMessage(messages[tab.id])}
        />
      ))}
    </Tabs>
  ) : null;
}

export default NavigationBar;
